import { useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '分类浏览', href: '#categories' },
  { label: '热门排行', href: '#ranking' },
  { label: '新上架', href: '#new' },
  { label: '完结作品', href: '#completed' },
  { label: '常见问题', href: '#faq' },
];

interface NavbarProps {
  onSearch: (keyword: string) => void;
  searchKeyword: string;
}

export default function Navbar({ onSearch, searchKeyword }: NavbarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const keyword = (e.currentTarget.elements.namedItem('keyword') as HTMLInputElement)?.value ?? '';
    onSearch(keyword.trim());
    document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur border-b border-background-200">
      <nav className="w-full max-w-[1440px] mx-auto px-4 md:px-6 h-16 flex items-center gap-4">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap group">
          <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center text-xl">
            <i className="ri-book-2-fill"></i>
          </span>
          <h1 className="font-heading text-xl md:text-2xl text-primary-700 group-hover:text-primary-600 transition-colors">
            4399漫画网
          </h1>
        </a>

        <div className="hidden lg:flex items-center gap-1 ml-6">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <form onSubmit={submitSearch} className="hidden md:flex flex-1 justify-end">
          <div className="relative w-full max-w-xs">
            <input
              type="text"
              name="keyword"
              defaultValue={searchKeyword}
              placeholder="搜索作品名 / 作者…"
              className="w-full h-10 pl-10 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-950 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition"
            />
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
          </div>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMobileOpen((v) => !v)}
          className="lg:hidden ml-auto w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-foreground-800"
        >
          <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <form onSubmit={submitSearch} className="mb-3 md:hidden">
            <div className="relative w-full">
              <input
                type="text"
                name="keyword"
                placeholder="搜索作品名 / 作者…"
                className="w-full h-10 pl-10 pr-4 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-950 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </form>
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}